import Vue from 'vue';
import {DateTime} from 'luxon';
import BigNumber from 'bignumber.js';
import {eventTypeOptions} from '@/sports-schedule/eventModels';
import {SocialMediaType} from '@/news-show/NewsShowModels';

export function installFilters() {
    Vue.filter('shortDate', (value: string) => {
        return DateTime.fromISO(value, { zone: 'America/Chicago'}).toLocaleString(DateTime.DATE_SHORT);
    });
    Vue.filter('dotFormattedDate', (value: string) => {
        return DateTime.fromISO(value, { zone: 'America/Chicago'}).toFormat('MM.dd.yyyy');
    });
    Vue.filter('simpleTime', (value: string) => {
        return DateTime.fromISO(value, {zone: 'America/Chicago'}).toLocaleString(DateTime.TIME_SIMPLE);
    });
    Vue.filter('dateMedium', (value: string) : string => {
        if (!value) {
            return '';
        }

        if (value.length === 10) {
            return DateTime.fromISO(value).toLocaleString(DateTime.DATE_MED);
        } else {
            return DateTime.fromISO(value, { zone: 'America/Chicago'}).toLocaleString(DateTime.DATE_MED);
        }
    });
    Vue.filter('removeFolder', (fileName: string) : string => {
        if (!fileName) {
            return ''
        }
        if (!fileName.includes('/')) {
            return fileName;
        }
        return fileName.substring(fileName.lastIndexOf('/') + 1);
    });
    Vue.filter('timeShortOffset', (value: string) : string => {
        return DateTime.fromISO(value, { zone: 'America/Chicago' }).toFormat('h:mm a ZZZZ')
    });
    Vue.filter('currency', (amount: string): string => {
        if (amount === '-' || amount === 'NaN') {
            return '-';
        }
        return '$' + new BigNumber(amount).toFixed(2, BigNumber.ROUND_HALF_EVEN);
    });
    Vue.filter('dateTimeShort', (value: string): string => {
        return DateTime.fromISO(value, {zone: 'America/Chicago'}).toLocaleString(DateTime.DATETIME_SHORT);
    });
    Vue.filter('timeRange', (value: {startDateTime: string, endDateTime: string}): string => {
        const startDateTime = DateTime.fromISO(value.startDateTime, {zone: 'America/Chicago'});
        const endDateTime = DateTime.fromISO(value.endDateTime, {zone: 'America/Chicago'});
        const startMeridiem = startDateTime.toFormat('a');
        const endMeridiem = endDateTime.toFormat('a');
        const startFormat = startMeridiem === endMeridiem ? 'h:mm' : 'h:mm a';
        return startDateTime.toFormat(startFormat) + ' - ' + endDateTime.toFormat('h:mm a ZZZZ');
    });
    Vue.filter('eventTypeDisplay',  (eventType: string): string => {
        if (!eventType) {
            return '';
        }
        const eventTypeToDisplay = eventTypeOptions.filter((eventTypeOption) => eventTypeOption.id === eventType);
        if (eventTypeToDisplay.length) {
            return eventTypeToDisplay[0].name;
        }
        return '';
    });
    Vue.filter('mapTrueTo',  (value: string, trueValue: string): string => {
        return value ? trueValue : '';
    });
    Vue.filter('capitalize',  (value: string): string => {
        if (!value) {
            return '';
        }
        value = value.toString().toLowerCase();
        return value.charAt(0).toUpperCase() + value.slice(1);
    });
    Vue.filter('fullName', (obj: {firstName: string, lastName: string}) => {
        return `${obj.firstName} ${obj.lastName}`;
    });
    Vue.filter('socialMediaType', (socialMediaType: SocialMediaType) => {
        if (!socialMediaType) {
            return '';
        }
        switch (socialMediaType) {
            case SocialMediaType.TWITTER:
                return 'Twitter';
            case SocialMediaType.FACEBOOK:
                return 'Facebook';
            case SocialMediaType.INSTAGRAM:
                return 'Instagram';
            case SocialMediaType.LINKED_IN:
                return 'Linked In';
            case SocialMediaType.YOUTUBE:
                return 'YouTube';
            default:
                return ''
        }
    });
    Vue.filter('twoDecimalFormat',  (value: string): string => {
        const value2Decimal = Number(value || '0').toFixed(2);
        return value2Decimal;
    });
    Vue.filter('textPlaceholder',  (value: string): string => {
        if(!value) {
            return 'DATA NEEDED';
        }
        return value;
    });
    Vue.filter('titleOrName',  ({name, title}: any): string => {
        if(title) {
            return title;
        }
        return name;
    });
}
